import { render, staticRenderFns } from "./BancaEmaticaRepartiEdit.vue?vue&type=template&id=84db5354"
import script from "./BancaEmaticaRepartiEdit.vue?vue&type=script&lang=js"
export * from "./BancaEmaticaRepartiEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports